import React from 'react';
import { Stack, Text } from '@mantine/core';

// Structured tooltip content for action buttons: what the action reads in, does, and updates.
// Rendered as a Mantine Tooltip `label` (which accepts JSX). Wrap the trigger in
// `<Tooltip label={<ActionHelp .../>} withArrow multiline w={300}>`.
export default function ActionHelp({ reads, does, updates }) {
  return (
    <Stack gap={2}>
      {reads && <Text size="xs"><b>Reads:</b> {reads}</Text>}
      {does && <Text size="xs"><b>Does:</b> {does}</Text>}
      {updates && <Text size="xs"><b>Updates:</b> {updates}</Text>}
    </Stack>
  );
}
